/* __next_internal_client_entry_do_not_use__ ModalsStoreContext,default,useModalsStore auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useRef } from 'react';
import { createModalsStore } from './modals';
import { useStore } from 'zustand';
export const ModalsStoreContext = /*#__PURE__*/ createContext(undefined);
export default function ModalsStoreProvider(param) {
    let { children } = param;
    // hooks
    const storeRef = useRef(null);
    if (storeRef.current === null) storeRef.current = createModalsStore();
    return /*#__PURE__*/ _jsx(ModalsStoreContext.Provider, {
        value: storeRef.current,
        children: children
    });
}
export const useModalsStore = (selector)=>{
    // hooks
    const modalsStoreContext = useContext(ModalsStoreContext);
    // check if context is ok
    if (!modalsStoreContext) throw new Error("useModalsStore must be used within ModalsStoreProvider");
    return useStore(modalsStoreContext, selector);
};
